module.exports = __webpack_public_path__ + "assets/images/bg_290c71cecfad782cfc8e14d29d89f042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 280
// module chunks = 0